import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import zh from "./locales/zh.json";
import ja from "./locales/ja.json";
import ms from "./locales/ms.json";
import pt from "./locales/pt.json";
// French covers the help centre only (help.*): the rest of the site UI isn't in French yet, so it falls back to
// English, and French isn't in `languages` (the site's language picker). See HELP_CONTENT_LANGS in src/content/help.
import frHelp from "./helpLocales/fr.json";

const isBrowser = typeof window !== "undefined";

// LanguageDetector reads localStorage/navigator, which don't exist under Node —
// only register it in the browser. On the server we render the fallback language
// deterministically, and the client re-detects + re-renders the correct language
// on hydration.
if (isBrowser) {
  i18n.use(LanguageDetector);
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    de: { translation: de },
    it: { translation: it },
    zh: { translation: zh },
    ja: { translation: ja },
    ms: { translation: ms },
    pt: { translation: pt },
    fr: { translation: frHelp },
  },
  // On the server force the fallback language so SSR output is deterministic and
  // matches the client's first (pre-detection) render.
  lng: isBrowser ? undefined : "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  detection: {
    // ?lang=xx first: the localised marketing pages' hreflang URLs (src/lib/seo), which the SSR server renders
    // in that language too (entry-server). The launch pages also take languages this UI doesn't have (fr, nl, no,
    // th): their copy follows ?lang=, and the nav and footer fall back to English (fallbackLng). Then the
    // visitor's saved choice.
    order: ["querystring", "localStorage", "navigator"],
    lookupQuerystring: "lang",
    caches: ["localStorage"],
  },
});

export default i18n;

export const languages = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "ms", label: "Bahasa Melayu", flag: "🇲🇾" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
];
